module.exports = __webpack_public_path__ + "static/media/14.7a781f08.jpg";